import React, { useEffect, useState } from 'react';
import { useRoutes } from 'react-router-dom';
import i18n from './i18n';
import getRoutes from './routes';
import { withTranslation } from "react-i18next";

const App = () => {

  const [currLang, setCurrLang] = useState(i18n.language || 'en');
  useEffect(() => {
    setCurrLang(i18n.language);
  }, [])

  const routing = useRoutes(getRoutes(currLang));
  return (
    <>
        {routing}
    </>
  );
};

export default withTranslation()(App);
